"use strict";

let AllowHideAllDivs = true;
let PageSizeCallback = () => { };
let PageResizeCallback = () => { };
let MenuScrollTop;
let Menu;
let MenuTop;
let PageEndMilliseconds = 0;
let AllowZoom = true;
let Switch;

function SetupEncompassSiteMapHeader() {
    setTimeout(() => {
        Menu = document.getElementById("Menu");
        MenuTop = document.getElementById("MenuTop");

        if (IsImpersonateUser) {
            if (Menu) {
                Menu.classList.add("MenuCollapsed");
            }

            const content = document.getElementById("Content");
            if (content) {
                content.classList.add("MenuCollapsed");
            }

            const application = document.querySelector("#Header .Application");
            if (application) {
                application.classList.add("MenuCollapsed");
            }
        }

        if (Menu) {
            // Task 698176: Removing a user's permission to view a certain dashboard does not remove it from their menu until after they click the 'Refresh' icon
            // Task 702904: Dashboard Menu is not showing the correct dashboards when logged in.
            const CurrentLocalStorageKey = `DashboardMenuHTML_${parseInt(Math.floor((new Date()) / 86400000))}_${UserID}_${UserType}_Key`;
            let DashboardMenuHTML;
            try {
                DashboardMenuHTML = EC_Fmt.GetLocalStorageValue(CurrentLocalStorageKey);
            } catch (e) {
                DashboardMenuHTML = "Cookies Must Be Enabled";
            }

            setTimeout(() => {
                if (DashboardMenuHTML !== "Cookies Must Be Enabled") {
                    for (let i = 0, len = localStorage.length; i < len; i++) {
                        const key = localStorage.key(i);
                        if (key && key.startsWith("DashboardMenuHTML_") && key !== CurrentLocalStorageKey) {
                            localStorage.removeItem(key);
                        }
                    }
                }
            }, 750);

            if (!DashboardMenuHTML) {
                let GetDashboardMenuURL = "api?APICommand=GetDashboardMenu";

                if (UserType === "Guest" || new Date().getTime() > parseInt(EC_Fmt.GetCookie("ExpireTime"))) {
                    const token = "bc1020ae20b607f7318ff7c782c6d8ef";
                    GetDashboardMenuURL += `_Guest&APIToken=${token}&EncompassID=${Distributor}&${EC_Fmt.Get_QueryString("", "DashboardID;DestURL", false, false)}`;
                } else {
                    // Task 701744: Open QuickLink left menu error happen.
                    GetDashboardMenuURL += `&${EC_Fmt.Get_QueryString("", "DashboardID;DashboardVersionID;DestURL;CustomerID;ProductID;ChainID;UserID;SupplierID;APAccountID;RouteID;QuickKey", true, true)}`;
                }

                fetch(GetDashboardMenuURL, {
                    credentials: "same-origin"
                }).then(response => response.text()).then((returnHTML) => {
                    // Task 715352: Menu showing user error Session Expired URL Does not include APIToken
                    if (returnHTML.startsWith("{")) {
                        EWS.Login(() => {
                            window.location.reload(true);
                        });
                    } else {
                        // Task 679154: Home>Menu: URL does not include APIToken and User is not logged on.
                        WriteDashboardMenuHTML(returnHTML);

                        // Task 938582: Error when loading the left side dashboard menu: cannot connect to database server
                        if (returnHTML.startsWith("<div")) {
                            // Task 951021: JavaScript Error: includes/DefaultAll.min.js (1) - uncaught exception: QuotaExceededError. use 14.22KB
                            EC_Fmt.SetLocalStorageValue(CurrentLocalStorageKey, returnHTML);
                        }
                    }
                });
            } else {
                WriteDashboardMenuHTML(DashboardMenuHTML);
            }

            let expandingTimeout;
            let collapsingTimeout;

            const Menumouseenter = () => {
                clearTimeout(collapsingTimeout);
                if (Menu.classList.contains("MenuCollapsed")) {
                    expandingTimeout = setTimeout(() => {
                        Menu.style.width = "256px";
                        Menu.querySelector(".Content").style.overflowY = "auto";
                        Menu.classList.add("open-temp");

                        const highlightedSection = Menu.querySelector(".CategoryHighlight.Relative");
                        if (highlightedSection) {
                            highlightedSection.style.background = "";
                            highlightedSection.style.boxShadow = "";

                            const expandedSubCategory = highlightedSection.querySelector("div[id$='Category']");
                            if (expandedSubCategory) {
                                expandedSubCategory.style.display = "";
                            }
                        }
                        if (MenuTop) {
                            MenuTop.style.width = "256px";
                            MenuTop.classList.remove("MenuCollapsed");
                            MenuTop.classList.add("MenuOpened");
                        }
                    }, 450);
                }
            };
            const Menumouseleave = () => {
                clearTimeout(expandingTimeout);
                if (Menu.style.width && Menu.classList.contains("MenuCollapsed")) {
                    collapsingTimeout = setTimeout(() => {
                        CollapseAndUnHighlightMenu();
                        Menu.style.width = "";
                        Menu.classList.remove("open-temp");
                        Menu.querySelector(".Content").style.overflowY = "hidden";
                        if (MenuTop) {
                            MenuTop.style.width = "";
                            MenuTop.classList.remove("MenuOpened");
                            MenuTop.classList.add("MenuCollapsed");
                        }
                    }, 450);
                }
            };
            if (MenuTop && !EC_Fmt.isMobile) {
                MenuTop.addEventListener("mouseenter", Menumouseenter, {
                    passive: true
                });
                MenuTop.addEventListener("mouseleave", Menumouseleave, {
                    passive: true
                });
                MenuTop.addEventListener("touchmove", (event) => {
                    event.stopPropagation();
                }, {
                    passive: true
                });
            }

            Menu.addEventListener("mouseenter", Menumouseenter, {
                passive: true
            });
            Menu.addEventListener("mouseleave", Menumouseleave, {
                passive: true
            });
            Menu.addEventListener("touchmove", (event) => {
                event.stopPropagation();
            }, {
                passive: true
            });

            requestIdleCallback(() => {
                Menu.scrollLeft = 0;
            });
        }

        const MainMenuItemHighlight = document.querySelector(".MainMenuItemHighlight");
        if (MainMenuItemHighlight && MainMenuItemHighlight.classList.contains("ews-unshared-menu-item") && window.Settings) {
            const MainMenuItemNoCategory = document.querySelector(".NoCategory");

            if (MainMenuItemNoCategory) {
                const addViewRoleDiv = document.createElement("div");
                addViewRoleDiv.classList.add("ActionButtonContainer");
                addViewRoleDiv.setAttribute("title", "Add View Role");
                addViewRoleDiv.innerHTML = `<a class='ActionButton ActionButtonEdit'href='Home?DashboardID=${ECP.CommonDashboards.TableView}&SubTableJoinID=DashboardsRoles_Dashboards&TableName=Dashboards&Search=DashboardID~${window.Settings.DashboardID}'id=ActionButtonAddViewRole><div class=Title><span class=ews-icon-edit></span>Add View Role</div></a>`;

                MainMenuItemNoCategory.appendChild(addViewRoleDiv);
            }
        }

        // Task 723415: If the DashboardID is not in the URL, add it so that sharing URLs with others and recently visited works correctly
        // Task 959560: Add EncompassID to the URL on test sites to make links to them work better
        // Task 1017499: The EC_Fmt.GetURLParameters method will not be processed '#'
        EC_Fmt.ReplaceState(window.history.state || {}, document.title, window.location.search + window.location.hash);

        // Task 723415: Add current page to the recently visited list
        if (UserType !== "Guest") {
            EWS.Ready(() => {
                // Task 723415: Setup a mutation observer to catch if the title on the page is updated, need to update the title in the RecentlyVistedPages cache
                // Task 1029399: System Error: JavaScript Error: includes/DefaultAll.min.js (1) - TypeError: window.WebKitMutationObserver is not a constructor
                const titleObserver = new window.MutationObserver(((mutations) => {
                    mutations.forEach((mutation) => {
                        let recentlyVisited = EC_Fmt.GetLocalStorageValue("RecentlyVisitedPages");
                        if (recentlyVisited) {
                            recentlyVisited = JSON.parse(recentlyVisited);
                        } else {
                            recentlyVisited = { pages: [] };
                        }
                        const lastIndex = recentlyVisited.pages.length - 1;
                        if (recentlyVisited.pages[lastIndex].title === "Table View") {
                            recentlyVisited.pages.splice(lastIndex, 1);
                        }
                        // Remove eChat notification from the title number
                        const cleanTitle = mutation.target.textContent.replace(/\(\d+\)$/, "");
                        for (let i = 0; i < recentlyVisited.pages.length; i++) {
                            if (recentlyVisited.pages[i].title === cleanTitle) {
                                recentlyVisited.pages.splice(i, 1);
                            }
                        }
                        recentlyVisited.pages.push({ title: cleanTitle, URL: window.location.pathname + window.location.search });
                        if (recentlyVisited.pages.length > 15) {
                            recentlyVisited.pages.shift();
                        }

                        EC_Fmt.SetLocalStorageValue("RecentlyVisitedPages", JSON.stringify(recentlyVisited));
                    });
                }));
                titleObserver.observe(document.querySelector("head > title"), { subtree: true, characterData: true, childList: true });

                // Task 723415: Pushing the current page into the recently visited list
                let recentlyVisited = EC_Fmt.GetLocalStorageValue("RecentlyVisitedPages");
                if (recentlyVisited) {
                    recentlyVisited = JSON.parse(recentlyVisited);
                } else {
                    recentlyVisited = { pages: [] };
                }
                // Remove eChat notification from the title number
                const cleanTitle = document.title.replace(/\(\d+\)$/, "");
                for (let i = 0; i < recentlyVisited.pages.length; i++) {
                    if (recentlyVisited.pages[i].title === cleanTitle) {
                        recentlyVisited.pages.splice(i, 1);
                    }
                }
                recentlyVisited.pages.push({ title: cleanTitle, URL: window.location.pathname + window.location.search });
                if (recentlyVisited.pages.length > 15) {
                    recentlyVisited.pages.shift();
                }
                EC_Fmt.SetLocalStorageValue("RecentlyVisitedPages", JSON.stringify(recentlyVisited));
            });
        }
    }, 100);
}

AllowZoom = true;

EWS.Ready(() => {
    let scrollTimer = null;
    const innerContent = document.querySelector("#Content .Inner");

    if (innerContent) {
        // Performance sensitive code, runs every time a user scrolls, for each pixel scrolled, please performance test if making changes
        let elementsHidden = false;
        innerContent.addEventListener("scroll", () => {
            if (!elementsHidden) {
                hideAllElements(document.getElementsByClassName("ews-menu"));
                hideAllElements(document.getElementsByClassName("AutocompleteMenu"));
                hideAllElements(document.querySelectorAll("body > .ColumnMenu"));
                hideAllElements(document.getElementsByClassName("DateInputCalendar"));
                elementsHidden = true;
            }

            clearTimeout(scrollTimer);

            scrollTimer = setTimeout(() => {
                EC_Fmt.ReplaceState(Object.assign(window.history.state || {}, {
                    scrollTop: innerContent.scrollTop,
                    scrollLeft: innerContent.scrollLeft
                }), "");
                elementsHidden = false;
            }, 700);
        }, {
            passive: true
        });
    }

    const MainLayout = document.getElementById("MainLayout");

    if (MainLayout && MainLayout.innerHTML.replace(/ /g, "") === "") {
        MainLayout.innerHTML = "&nbsp;";
    }

    let resizeTimeout;
    window.addEventListener("resize", () => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(() => {
            ResizeLayout();
        }, 150);
    });
    window.addEventListener("click", (event) => {
        if (event.button !== 2) {
            HideAllDivs(false);
        }
    });

    // Zoom on mobile
    if (EC_Fmt.isMobile) {
        let isScale = false;
        let dist = 0;
        let scale = 1;
        const mainLayoutTable = document.getElementById("MainLayoutTable");

        if (mainLayoutTable) {
            const zoomables = document.querySelectorAll(".Zoomable");
            const DashboardElement = document.getElementById("Dashboard");

            innerContent.style.transition = "transform 0.2s";

            innerContent.addEventListener("touchstart", (event) => {
                if (AllowZoom) {
                    const originalEvent = event;

                    if (originalEvent.touches.length === 2) {
                        isScale = true;

                        dist = Math.sqrt(
                            (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX) * (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX)
                            + (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY) * (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY)
                        );
                    }
                }
            }, {
                passive: true
            });

            innerContent.addEventListener("touchmove", (event) => {
                if (isScale && AllowZoom) {
                    const originalEvent = event;

                    if (originalEvent.touches.length < 2 || !originalEvent.touches[0] || !originalEvent.touches[1]) {
                        return false;
                    }

                    const currentDist = Math.sqrt(
                        (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX) * (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX)
                        + (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY) * (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY)
                    );

                    const diff = currentDist - dist;

                    if (Math.abs(diff) >= 10) {
                        const currentScale = scale + 0.0001 * (currentDist - dist);

                        if (mainLayoutTable.scrollWidth * currentScale >= window.outerWidth && currentScale <= 1.8) {
                            if (DashboardElement) {
                                DashboardElement.style.transform = `scale(${currentScale})`;
                                DashboardElement.style.transformOrigin = "0 0";
                                DashboardElement.style.width = DashboardElement.offsetWidth / scale * currentScale;
                            } else {
                                mainLayoutTable.style.transform = `scale(${currentScale})`;
                                mainLayoutTable.style.transformOrigin = "0 0";
                            }

                            for (let i = 0; i < zoomables.length; i++) {
                                const zoomable = zoomables[i];

                                zoomable.style.transform = `scale(${currentScale})`;
                                zoomable.style.transformOrigin = "0 0";
                            }

                            scale = currentScale;
                        }
                    }

                    return false;
                }
                return true;
            }, {
                passive: true
            });

            innerContent.addEventListener("touchend", () => {
                isScale = false;
                dist = 0;
            }, {
                passive: true
            });
        }

        const ApplicationVersionLinks = document.querySelectorAll(".application-versions a");
        for (let i = 0; i < ApplicationVersionLinks.length; i++) {
            ApplicationVersionLinks[i].addEventListener("click", () => {
                ECP.Dialog.Alert("Encompass Mobile download has started. Please exit your browser to view the progress.");
            });
        }
    }

    // Task 911147: Browser Render time is not accurate on dashboards
    PageEndMilliseconds = new Date().getTime();

    const MainLayoutHeader = document.getElementById("MainLayoutHeader");
    if (MainLayoutHeader) {
        const previousEl = MainLayoutHeader.previousElementSibling;

        if (previousEl && previousEl.tagName.toLowerCase() === "tbody") {
            MainLayoutHeader.parentElement.insertBefore(MainLayoutHeader, previousEl);
        }
    }

    if (window.history.state && (window.history.state.scrollLeft !== undefined || window.history.state.scrollTop !== undefined)) {
        innerContent.scrollTo(window.history.state.scrollLeft, window.history.state.scrollTop);
    }

    ShowToolTipMessage();

    CreateSwitchDashboardVersionTypeButton(document.querySelector("#Header .Inner .switchVersionTypeContent"));

    // Task 1038521: Collapse dashboard header tabs when the user scrolls away from the header
    if (document.querySelector("#MainLayoutTable .HeaderTabsSticky")) {
        document.querySelector("#MainLayoutTable").classList.add("OverflowInherit");
    }

    // 修改Menu
    const OverFlowMenu = document.getElementById("OverFlowMenu");
    if (OverFlowMenu) {
        const btn = OverFlowMenu.shadowRoot.querySelector("button");
        if (Distributor.indexOf("SPTest") !== -1) {
            btn.style.color = "#FCFDFF";
        }
        btn.style.fontSize = "30px";
        OverFlowMenu.addEventListener("click", async (e) => {
            let HeaderOverflowMenu = document.getElementById("HeaderOverflowMenu");
            if (!HeaderOverflowMenu) {
                HeaderOverflowMenu = GetHeaderOverflowMenu();
                OverFlowMenu.parentElement.insertBefore(HeaderOverflowMenu, OverFlowMenu.nextSibling);
                SetRenderTime();
            }
            HeaderOverflowMenu.ShowMenu(OverFlowMenu);
            e.stopPropagation();
        });
    }
});

function GetHeaderOverflowMenu() {
    let HeaderOverflowMenu = '<ecp-menu id="HeaderOverflowMenu"><ecp-list type="clickable"><ecp-list-item id="BreadCrumbMenuArrow" onclick="ToggleMainMenu()" class="Application">';
    if (EC_Fmt.GetCookie("MenuCollapsed") === "False") {
        HeaderOverflowMenu += `<span class="menu-status-icon ews-icon-password"></span><ecp-list-item-title>${EC_Fmt.Trn("Lock sidebar open")}</ecp-list-item-title>`;
    } else {
        HeaderOverflowMenu += `<span class="menu-status-icon ews-icon-unlock"></span><ecp-list-item-title>${EC_Fmt.Trn("Auto-collapse sidebar")}</ecp-list-item-title>`;
    }
    HeaderOverflowMenu += `</ecp-list-item><ecp-list-item onclick="refreshMenu()" id="RefreshMenu"><span class="ews-icon-refresh"></span><ecp-list-item-title>${EC_Fmt.Trn("Refresh dashboard list")}</ecp-list-item-title></ecp-list-item></ecp-list></ecp-menu>`;
    HeaderOverflowMenu = EC_Fmt.HtmlStrToElement(HeaderOverflowMenu);
    HeaderOverflowMenu.addEventListener("click", (event) => {
        const target = event.target.matches("ecp-list-item") || event.target.closest("ecp-list-item");
        if (target) {
            event.target.closest("ecp-menu").style.display = "none";
        }
    });
    return HeaderOverflowMenu;
}

function CreateSwitchDashboardVersionTypeButton(switchVersionTypeContent, isMobile) {
    if (window.Settings && window.Settings.ExistsBetaVersion && switchVersionTypeContent) {
        let html = "";

        if (isMobile) {
            html = "<div class=ews-menu-item name=SwitchVersionMenuItem>"
                + "<span class=\"ews-menu-icon ews-icon-dashboard\"></span>"
                + "<span class=\"ews-menu-label inline-block\"style=max-width:170px>View Beta Version</span>"
                + "<div style=position:absolute;right:0;padding-right:16px>";
        }

        html += "<div class=\"toggle-multiple-labels Label\">"
            + "<div class=toggle-switch-widget>"
            + "<div class=toggle-layer-small>"
            + `<input id=switchVersionTypeInput${isMobile ? "Mobile" : ""} type=checkbox class=toggle-switch-checkbox${window.Settings.EnableBeta ? " checked" : ""}>`
            + `<label class=switch-icon for=switchVersionTypeInput${isMobile ? "Mobile" : ""}>`
            + "</div>"
            + `${isMobile ? "" : "<span style=font-size:16px;font-weight:700;padding-left:5px;user-select:none>Beta</span>"}`
            + "</div>"
            + "</div>";

        if (isMobile) {
            html += "</div></div>";
        }

        switchVersionTypeContent.innerHTML = html;

        const switchVersionTypeInput = switchVersionTypeContent.querySelector("#switchVersionTypeInput, .ews-menu-item[name='SwitchVersionMenuItem']");

        switchVersionTypeInput.addEventListener("click", async () => {
            // Task 1033298: Adding Google Analytics as a default feature of dashboards
            gtag("event", "switchDashboardVersionType", { enableBeta: window.Settings.EnableBeta });
            ECP.Dialog.ShowLoading();

            const myRequest = new ECP.EC_Request("Dashboard_SwitchDashboardVersionType");

            myRequest.AddRequestVariable("DashboardID", window.Settings.DashboardID);
            myRequest.AddRequestVariable("EnableBeta", !window.Settings.EnableBeta);

            const data = await myRequest.Submit();

            ECP.Dialog.HideLoading();

            if (data.status === "success") {
                window.location.reload();
            }
        });
    }
}

function clearDashboardMenuCache() {
    // Task 705574: Show More Dashboards button does not respond on iOS Safari
    try {
        localStorage.removeItem(`DashboardMenuHTML_${parseInt(Math.floor((new Date()) / 86400000))}_${UserID}_${UserType}_Key`);
        // Task 916139: Redesigning the public web site with a different menu
        localStorage.removeItem(`PublicSiteMenuHTML_${parseInt(Math.floor((new Date()) / 86400000))}_${UserType}`);
    } catch (e) {
        // Ignore, cookie requirement message will be shown when page refreshes (just after this)
    }
}
function setPageBreadcrumbTitle(Breadcrumb, BreadcrumbURL, Title, Button) {
    let htmlB = "";
    if (!EC_Fmt.isNull(BreadcrumbURL) && !EC_Fmt.isNull(Breadcrumb)) {
        htmlB += `<a href="${BreadcrumbURL}">${Breadcrumb}</a> <span class=cut-off-line>/</span> `;
    } else if (!EC_Fmt.isNull(Breadcrumb)) {
        htmlB += `${Breadcrumb} <span class=>/</font> `;
    }
    htmlB += `<label class=font-bold>${Title}</label>`;
    if (Button) {
        htmlB += `<div class=PageBreadcrumb-button>${Button}</div>`;
    }

    document.getElementById("PageBreadcrumb_Title").innerHTML = htmlB;
}
function WriteDashboardMenuHTML(DashboardMenuHTML) {
    // Task 636615: End of day error
    let HeaderMenuLoading = Menu.querySelector("#HeaderMenuLoading");
    if (HeaderMenuLoading) {
        const currentCategoryName = HighlightMenu(DashboardMenuHTML, HeaderMenuLoading);

        HeaderMenuLoading.id = "";
        HeaderMenuLoading.setAttribute("id", "");
        HeaderMenuLoading = undefined;

        if (currentCategoryName) {
            ToggleMenuCategory(currentCategoryName, true);
        }

        if (Menu.classList.contains("MenuCollapsed")) {
            CollapseAndUnHighlightMenu();
        }

        EncompassMobileItem();
    }

    const shareButton = Menu.querySelector("#ActionButtonShare");

    if (shareButton) {
        shareButton.addEventListener("click", (event) => {
            event.preventDefault();
            Load_QuicklinkMenu(shareButton, `Home?${EC_Fmt.Get_QueryString(" ")}`, "Dashboard");
        });
    }
}

// Task 1058438: Master Task 1058050: mobile when open Side Menu, page is very narrow and still can use
function hideAllElements(elements) {
    if (elements) {
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
        }
    }
}

function CollapseAndUnHighlightMenu() {
    const highlightedSection = Menu.querySelector(".CategoryHighlight.Relative");
    if (highlightedSection) {
        highlightedSection.style.background = "unset";
        highlightedSection.style.boxShadow = "unset";

        const expandedSubCategory = highlightedSection.querySelector("div[id$='Category']");
        if (expandedSubCategory) {
            expandedSubCategory.style.display = "none";
        }
    }
}

function SetRenderTime() {
    const loadTime = document.getElementById("PageLoadTime");
    if (loadTime) {
        loadTime.textContent = `${EC_Fmt.Trn("Server Time")}: ${PageLoadTime} sec`;
    }

    const renderTime = document.getElementById("RenderTime");
    if (renderTime) {
        // Task 911147: Browser Render time is not accurate on dashboards
        renderTime.textContent = `${EC_Fmt.Trn("Browser Render")}: ${Math.round(Math.abs((PageStartMilliseconds - PageEndMilliseconds) / 1000) * 100) / 100} sec`;
    }

    setInternetSpeed();
}

function setInternetSpeed() {
    const internetSpeed = document.getElementById("InternetSpeed");
    if (internetSpeed) {
        const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        if (isLocalhost) {
            internetSpeed.innerHTML = `${EC_Fmt.Trn("Internet Speed")}: &#8734; {localhost}`;
        } else if (navigator.connection && navigator.connection.downlink) {
            if (navigator.connection.downlink >= 10) {
                internetSpeed.textContent = `${EC_Fmt.Trn("Internet Speed")}: 10+ Mbps`;
            } else if (navigator.connection.downlink < 0.75) {
                internetSpeed.style.backgroundColor = "red";
                internetSpeed.textContent = `${EC_Fmt.Trn("Internet Speed")}: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps (${EC_Fmt.Trn("Very Slow")})`;
            } else if (navigator.connection.downlink < 2) {
                internetSpeed.style.backgroundColor = "orange";
                internetSpeed.textContent = `${EC_Fmt.Trn("Internet Speed")}: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps (${EC_Fmt.Trn("Slow")})`;
            } else {
                internetSpeed.textContent = `${EC_Fmt.Trn("Internet Speed")}: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps`;
            }

            if (navigator.connection.rtt > 250) {
                if (EC_Fmt.isNull(internetSpeed.style.backgroundColor)) {
                    internetSpeed.style.backgroundColor = "orange";
                }
                internetSpeed.textContent += ` (${EC_Fmt.Trn("High Latency")})`;
            }
        } else {
            internetSpeed.textContent = `${EC_Fmt.Trn("Internet Speed: unknown")}`;
        }
    }
}

function SubmitTo(Id, Url) {
    const Form = document.getElementById(Id);

    if (Form) {
        Form.setAttribute("action", Url);
        Form.submit();
    }
}

function RegisterPageSizeCallback(Callback) {
    if (Callback) {
        const CurrentFunction = PageSizeCallback;

        PageSizeCallback = () => {
            CurrentFunction();
            Callback();
        };
    }
}

function RegisterPageResizeCallback(Callback) {
    if (Callback) {
        const CurrentFunction = PageResizeCallback;

        PageResizeCallback = () => {
            CurrentFunction();
            Callback();
        };
    }
}

function ResizeLayout(NeedScrollToCurrent) {
    let AllowResize = true;

    if (EWS && EWS.AllowResize) {
        AllowResize = EWS.AllowResize;
    }

    if (EC_Fmt.isMobile) {
        const userMenu = document.getElementById("ews-BC_EWS_UserMenu-menu");
        if (userMenu && !(userMenu.offsetWidth === 0 && userMenu.offsetHeight === 0)) {
            EWS.Command.HideMenu("BC_EWS_UserMenu");
            EWS.Command.ShowMenu("BC_EWS_UserMenu", document.querySelector("#Header .Inner .LabelButton[name=UserMenu]"));
        }
    }

    if (AllowResize) {
        EWS.windowInnerHeight = window.innerHeight;
        EWS.windowInnerWidth = window.innerWidth;

        if (document.body && document.body.style.position !== "fixed") {
            PageResizeCallback();
            SetLayoutHeight(NeedScrollToCurrent, MenuScrollTop, Menu);
        }
    }
}

function SetLayoutHeight(NeedScrollToCurrent, NewMenuTop, LeftSideMenu) {
    if (!LeftSideMenu) {
        LeftSideMenu = Menu;
    }

    if (LeftSideMenu) {
        if (NeedScrollToCurrent) {
            let top = 0;
            const MainMenuItemHighlight = LeftSideMenu.querySelector(".MainMenuItemHighlight");
            if (MainMenuItemHighlight) {
                top = MainMenuItemHighlight.getBoundingClientRect().top - LeftSideMenu.getBoundingClientRect().top;
            }

            if ((top - LeftSideMenu.outerHeight) > LeftSideMenu.scrollTop) {
                top -= LeftSideMenu.outerHeight / 2;

                LeftSideMenu.scrollTop = top;
            }
        } else {
            LeftSideMenu.scrollTop = NewMenuTop;
        }
    }

    if (EC_Fmt.isMobile) {
        const myDashboard = document.getElementById("Dashboard");

        if (myDashboard) {
            const MainContent = document.getElementById("Content");
            if (Menu && Menu.classList.contains("MenuOpened") && !Menu.classList.contains("FullMenu") && !Menu.classList.contains("MenuCollapsed")) {
                MainContent.style.display = `none`;
            } else {
                // Task 1033489: No list of packaging orders displayed
                MainContent.style.display = "flex";
            }
        }

        requestAnimationFrame(() => {
            document.querySelector("meta[name=viewport]").setAttribute("content", `height=${window.outerHeight},width=device-width,minimum-scale=1.0,maximum-scale=1.0,initial-scale=1.0,user-scalable=no`);
        });
    } else {
        PageSizeCallback();
    }
}

function LoadKnowledgeHelpAlerts() {
    const KnowledgeHelpAlert = document.getElementById("KnowledgeHelpAlert");

    if (KnowledgeHelpAlert) {
        const KnowledgeHelpKey = KnowledgeHelpAlert.getAttribute("KnowledgeHelpKey");
        const KnowledgeHelpKeyValue = KnowledgeHelpAlert.getAttribute("KnowledgeHelpKeyValue");

        if (EC_Fmt.isNull(KnowledgeHelpKey) || EC_Fmt.isNull(KnowledgeHelpKeyValue)) {
            return;
        }

        EWS.VerifySession(() => {
            fetch(`api?APICommand=GetKnowledgeHelpAlerts&KnowledgeHelpKey=${KnowledgeHelpKey}&KnowledgeHelpKeyValue=${KnowledgeHelpKeyValue}`, {
                credentials: "same-origin"
            }).then(response => response.json()).then((Data) => {
                if (Data.TotalCount && Data.TotalCount !== "0") {
                    KnowledgeHelpAlert.style.display = "inline-table";
                }
            });
        });
    }
}

function HideAllDivs(DestroyContent) {
    if (AllowHideAllDivs) {
        const hideableDivs = document.getElementsByClassName("Hideable");
        if (hideableDivs.length > 0) {
            let includesMobileTouchOverItem = false;

            if (window.MobileCurrentInput) {
                for (let i = 0; i < hideableDivs.length; i++) {
                    if (hideableDivs[i].contains(window.MobileCurrentInput)) {
                        includesMobileTouchOverItem = true;
                        break;
                    }
                }
            }

            if (!includesMobileTouchOverItem) {
                for (let i = 0; i < hideableDivs.length; i++) {
                    hideableDivs[i].style.display = "none";
                    if (DestroyContent === true) {
                        hideableDivs[i].innerHTML = "";
                    }
                }

                if (EC_Fmt.isMobile) {
                    document.getElementById("Content").classList.remove("overflow-hidden");
                }
            }
        }
    } else {
        AllowHideAllDivs = true;
    }
}

function GetXY(Element) {
    if (window.jQuery && Element instanceof window.jQuery) {
        Element = Element[0];
    }

    const myPosition = Element.getBoundingClientRect();

    return {
        X: myPosition.left,
        Y: myPosition.top
    };
}

function GetX(Element) {
    return GetXY(Element).X;
}

function GetY(Element) {
    return GetXY(Element).Y;
}

function ToggleMainMenu() {
    if (UserType !== "Guest" && IsImpersonateUser) {
        return false;
    }

    if (!Menu.classList.contains("MenuCollapsed")) {
        if (!EC_Fmt.isMobile) {
            document.cookie = "MenuCollapsed=True;path=/";
        }
        SiteMenuToggle(true);
    } else {
        if (!EC_Fmt.isMobile) {
            document.cookie = "MenuCollapsed=False;path=/";
        }
        SiteMenuToggle(false);
    }
}

function SiteMenuToggle(visible, LeftSideMenu) {
    if (!LeftSideMenu) {
        LeftSideMenu = Menu;
    }
    const BreadCrumbMenu = document.getElementById("BreadCrumbMenuArrow");
    Menu.classList.remove("open-temp");
    LeftSideMenu.querySelector(".Content").removeAttribute("style");
    if (BreadCrumbMenu && BreadCrumbMenu.querySelector("span")) {
        const BreadCrumbMenuIcon = BreadCrumbMenu.querySelector("span");
        if (visible) {
            BreadCrumbMenuIcon.classList.remove("ews-icon-unlock");
            BreadCrumbMenuIcon.classList.add("ews-icon-password");
            BreadCrumbMenu.querySelector("ecp-list-item-title").textContent = EC_Fmt.Trn("Lock sidebar open");
        } else {
            BreadCrumbMenuIcon.classList.remove("ews-icon-password");
            BreadCrumbMenuIcon.classList.add("ews-icon-unlock");
            BreadCrumbMenu.querySelector("ecp-list-item-title").textContent = EC_Fmt.Trn("Auto-collapse sidebar");
        }
    }
    const Content = document.getElementById("Content");
    const headerApplication = document.querySelector("#Header .menu-in-header");

    LeftSideMenu.style.width = "";

    const categoryHighlight = document.getElementById("MenuInnerContents").querySelector(".CategoryHighlight");

    const mobileMenuMask = LeftSideMenu.parentElement.querySelector("#MobileMenuMask");
    if (visible) {
        if (EC_Fmt.isMobile) {
            // Task 1058438: mobile when open Side Menu, page is very narrow and still can use
            const resetPositionAfterAnimationEnd = () => {
                if (mobileMenuMask && document.getElementById("Menu").classList.contains("MenuCollapsed")) {
                    mobileMenuMask.remove();
                }
                LeftSideMenu.removeEventListener("transitionend", resetPositionAfterAnimationEnd);
            };

            LeftSideMenu.addEventListener("transitionend", resetPositionAfterAnimationEnd);
        }
        if (UserType !== "Guest" && !EC_Fmt.isMobile) {
            fetch("api?APICommand=SetMenuStatus&Collapsed=true", {
                credentials: "same-origin"
            });
        }

        LeftSideMenu.classList.add("MenuCollapsed");
        LeftSideMenu.classList.remove("MenuOpened");
        Content.classList.add("MenuCollapsed");
        Content.classList.remove("MenuOpened");

        if (headerApplication && !EC_Fmt.isMobile) {
            headerApplication.classList.add("MenuCollapsed");
            headerApplication.classList.remove("MenuOpened");
            headerApplication.style.width = "";
        }

        if (categoryHighlight) {
            const mainMenuCategory = categoryHighlight.querySelector(".MainMenuCategory");
            mainMenuCategory.nextElementSibling.style.display = "none";

            mainMenuCategory.querySelector(".ews-icon-emcaretdown").classList.remove("arrowup");
            categoryHighlight.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
        }
    } else {
        // Task 1058438: mobile when open Side Menu, page is very narrow and still can use
        if (EC_Fmt.isMobile) {
            if (!mobileMenuMask && !visible) {
                const mobileMenuMaskDIV = document.createElement("div");
                mobileMenuMaskDIV.id = "MobileMenuMask";
                mobileMenuMaskDIV.style = "position:fixed;z-index:199;top:0;left:0;width:100%;height:100%;background-color:var(--neutral-120);opacity:0.08";
                mobileMenuMaskDIV.addEventListener("click", () => { SiteMenuToggle(true); });
                LeftSideMenu.parentElement.appendChild(mobileMenuMaskDIV);
            }
        }
        if (UserType !== "Guest" && !EC_Fmt.isMobile) {
            fetch("api?APICommand=SetMenuStatus&Collapsed=false", {
                credentials: "same-origin"
            });
        }

        LeftSideMenu.classList.add("MenuOpened");
        LeftSideMenu.classList.remove("MenuCollapsed");
        Content.classList.add("MenuOpened");
        Content.classList.remove("MenuCollapsed");

        if (headerApplication && !EC_Fmt.isMobile) {
            headerApplication.classList.add("MenuOpened");
            headerApplication.classList.remove("MenuCollapsed");
        }

        if (categoryHighlight) {
            categoryHighlight.style.background = "";
            categoryHighlight.style.boxShadow = "";
            const mainMenuCategory = categoryHighlight.querySelector(".MainMenuCategory");
            mainMenuCategory.nextElementSibling.style.display = "block";
            mainMenuCategory.querySelector(".ews-icon-emcaretdown").classList.add("arrowup");
        }
    }
}


function HighlightMenu(DashboardMenuHTML, HeaderMenuLoading) {
    const dashboardId = EC_Fmt.GetPageParameter("DashboardID");
    const tempDiv = document.createElement("div");

    tempDiv.innerHTML = DashboardMenuHTML;

    const currentPrimaryDashboard = tempDiv.querySelector(`.MainMenuPrimaryDashboards[PrimaryDashboardID='${dashboardId}']`);
    if (currentPrimaryDashboard) {
        currentPrimaryDashboard.classList.add("MainMenuPrimaryHighlight");
    }

    const oldCategory = tempDiv.querySelector(".CategoryHighlight");
    const oldMenuItem = tempDiv.querySelector(".MainMenuItemHighlight");
    const currentURL = window.location.href.substring(window.location.href.indexOf("aspx1") + 6);
    let currentMenuLink = tempDiv.querySelector(`.FavoritesSubcategory a[href*='${currentURL}']`);

    if (!currentMenuLink || currentMenuLink.href.substring(window.location.href.indexOf("aspx1") + 6) !== currentURL) {
        currentMenuLink = tempDiv.querySelector(`.MainMenuItem a[href*='Home?DashboardID=${dashboardId}']`);
        if (currentMenuLink && currentMenuLink.parentElement.classList.contains("FavoritesSubcategory")) {
            currentMenuLink = null;
        }
    } else {
        // Task 738573: Edit Dashboard button is grayed out on left side menu and I am the owner.
        const dashboardMenuLink = tempDiv.querySelector(`.MainMenuItem:not(.FavoritesSubcategory) a[href*='Home?DashboardID=${dashboardId}']`);

        if (dashboardMenuLink) {
            const dashboardEditIDArr = dashboardMenuLink.parentElement.getAttribute("dashboardeditidarr");

            if (dashboardEditIDArr) {
                currentMenuLink.parentElement.setAttribute("dashboardeditidarr", dashboardEditIDArr);
            }
        }
    }

    let currentMenuItem = currentMenuLink ? currentMenuLink.parentElement : null;

    if (!currentMenuLink && !currentMenuItem) {
        currentMenuItem = tempDiv.querySelector(`.MainMenuItem[dashboardidarr*="^${dashboardId}^"]`);
    }

    // const getOpenNewPage = async () => {
    //     let OpenNewPage = "0";
    //     const myValue = localStorage.getItem("OpenNewPage");
    //     if (!EC_Fmt.isNull(myValue)) {
    //         OpenNewPage = localStorage.getItem("OpenNewPage");
    //     } else {
    //         const myTableView = new ECP.EC_TableView("Settings");
    //         myTableView.SetFormat("json");
    //         myTableView.SetMaxRecords(1);
    //         myTableView.AddFilter("SettingID", "3061^0");
    //         myTableView.AddColumn("Setting");
    //         const data = await myTableView.GetResults();
    //         const myRecordSet = new ECP.EC_Recordset(data);
    //         if (!myRecordSet.EOF) {
    //             OpenNewPage = myRecordSet.ItemDBValue("Setting");
    //         }
    //         localStorage.setItem("OpenNewPage", OpenNewPage);
    //     }

    //     if (currentMenuLink && OpenNewPage === "1") {
    //         const linkList = tempDiv.querySelectorAll("a");
    //         for (let i = 0; i < linkList.length; i++) {
    //             linkList[i].setAttribute("target", "_blank");
    //         }
    //     }
    // };
    // getOpenNewPage();

    let currentCategoryName = "";

    if (oldCategory) {
        const arrow = oldCategory.querySelector(".arrowup");

        if (arrow) {
            arrow.classList.remove("arrowup");
        }

        oldCategory.querySelector("div[id*='Category']").style.display = "none";

        if (oldMenuItem) {
            oldMenuItem.classList.remove("MainMenuItemHighlight");
        }
    }

    if (currentMenuItem) {
        currentMenuItem.classList.add("MainMenuItemHighlight");
        currentCategoryName = currentMenuItem.parentElement.id.replace("Category", "");
    }

    // Task 688388: CRM -> Customer Search Dashboard: Customer Dashboard is Not Taking User Back to Correct Page
    const dashboardMenuItemArr = tempDiv.querySelectorAll("[dashboardmenufilter]");
    for (let i = 0; i < dashboardMenuItemArr.length; i++) {
        const dashboardMenuItem = dashboardMenuItemArr[i];

        let FieldName = "";
        switch (dashboardMenuItem.getAttribute("dashboardmenufilter")) {
            case "Customer":
                FieldName = "CustomerID";
                break;
            case "Product":
                FieldName = "ProductID";
                break;
            case "Chain":
                FieldName = "ChainID";
                break;
            case "User":
                FieldName = "UserID";
                break;
            case "Supplier":
                FieldName = "SupplierID";
                break;
            case "APAccount":
                FieldName = "APAccountID";
                break;
            case "Route":
                FieldName = "RouteID";
                break;
        }

        if (FieldName !== "") {
            if (EC_Fmt.isInteger(EC_Fmt.GetPageParameter(FieldName))) {
                dashboardMenuItem.href += `&${FieldName}=${EC_Fmt.GetPageParameter(FieldName)}`;
            } else if (EC_Fmt.Null2EmptyStr(EC_Fmt.GetPageParameter("Parameters")).indexOf(FieldName) > -1) {
                const parameterArr = EC_Fmt.Null2EmptyStr(EC_Fmt.GetPageParameter("Parameters")).split("|");
                for (let j = 0; j < parameterArr.length; j++) {
                    const parsingParameterArr = parameterArr[j].split("~");
                    if (parsingParameterArr[0].split(":")[1] === FieldName) {
                        dashboardMenuItem.href += `&${FieldName}=${parsingParameterArr[1].split(":")[1]}`;
                        break;
                    }
                }
            }
        }
    }

    HeaderMenuLoading.innerHTML += tempDiv.innerHTML;

    const selectedDashboard = HeaderMenuLoading.querySelector(".MainMenuItemHighlight");
    const EditDashboardBtn = HeaderMenuLoading.querySelector("#ActionButtonEditDashboard");

    if (EditDashboardBtn) {
        if (!dashboardId || !selectedDashboard || !selectedDashboard.getAttribute("dashboardEditIDArr") || !selectedDashboard.getAttribute("dashboardEditIDArr").includes(dashboardId)) {
            EditDashboardBtn.classList.add("disabled");
            EditDashboardBtn.parentElement.setAttribute("title", "Edit Dashboard - You must be the owner of the dashboard, or have Shared Dashboard Edit permission");
            EditDashboardBtn.removeAttribute("href");
        } else {
            EditDashboardBtn.href = `Home?DashboardEdit=true&DashboardID=${dashboardId}`;
        }
    }
    return currentCategoryName;
}

function ToggleExcelMenu(Button, Name) {
    const ExcelMenu = document.getElementById(Name);

    if (ExcelMenu && ExcelMenu.offsetWidth === 0 && ExcelMenu.offsetHeight === 0) {
        HideAllDivs();
        AllowHideAllDivs = false;

        const buttonPosition = Button.getBoundingClientRect();

        ExcelMenu.style.display = "block";
        ExcelMenu.style.top = `${buttonPosition.top + buttonPosition.height + 3}px`;
        ExcelMenu.style.left = `${buttonPosition.left}px`;
        ExcelMenu.style.zIndex = "9999";
    }
}

function ShowSwitchDialog() {
    if (AuthenticationID > 0) {
        EWS.VerifySession(() => {
            // Task 614359: Convert EWS.aspx from an aspx page to API Commands/Dashboard
            fetch(`api?APICommand=CreateSiteSwitchDialog&EncompassID=${Distributor}`, {
                credentials: "same-origin"
            }).then(response => response.json()).then((result) => {
                // Task 657698: Clone User / Switch Site vulnerability.
                if (result.Tips === undefined) {
                    // Task 1064395: Change the 'Switch site' modal to be an action type dialog
                    Switch = result.switch;
                    const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                        width: 350,
                        height: 420,
                        barPosition: "top",
                        confirmButtonTitle: result.cancel,
                        confirmButtonAction(dialog) {
                            ECP.Dialog.CloseDialog(dialog);
                        }
                    });

                    Dialog.querySelector(".ews-form-content").style.cssText += "width:100%;height:100%;position:relative;box-sizing:border-box;user-select:none";

                    Dialog.querySelector(".ecp-dialog-confirm-button").classList.add("ecp-dialog-cancel-button");
                    Dialog.querySelector(".ecp-dialog-confirm-button").classList.remove("ecp-dialog-confirm-button");

                    Dialog.querySelector("input#SiteSearchInput").addEventListener("keydown", (event) => {
                        // Task 949378: Switch Site: Change functionality of hitting enter key after typing EncompassID
                        const ItemArr = Array.from(document.querySelectorAll(".database-list-item.show"));
                        switch (event.key) {
                            case "ArrowUp":
                                {
                                    const dom = document.querySelector(".database-list-item.show.highlight");
                                    if (!EC_Fmt.isNull(ItemArr)) {
                                        let index = ItemArr.indexOf(dom);
                                        if (index <= 0) {
                                            index = ItemArr.length - 1;
                                        } else if (index <= (ItemArr.length - 1)) {
                                            index -= 1;
                                        }
                                        for (let i = 0, len = ItemArr.length; i < len; i++) {
                                            ItemArr[i].classList.remove("highlight");
                                            ItemArr[i].childNodes[0].childNodes[1].style = "color:#666";
                                        }
                                        ItemArr[index].classList.add("highlight");
                                        ItemArr[index].childNodes[0].childNodes[1].style = "color:#fff";

                                        if (ItemArr[index].scrollIntoViewIfNeeded) {
                                            ItemArr[index].scrollIntoViewIfNeeded();
                                        } else {
                                            ItemArr[index].scrollIntoView();
                                        }
                                    }
                                    break;
                                }
                            case "ArrowDown":
                                {
                                    const dom = document.querySelector(".database-list-item.show.highlight");
                                    if (!EC_Fmt.isNull(ItemArr)) {
                                        let index = ItemArr.indexOf(dom);
                                        if (index < (ItemArr.length - 1)) {
                                            index += 1;
                                        } else if (index >= (ItemArr.length - 1)) {
                                            index = 0;
                                        }
                                        for (let i = 0, len = ItemArr.length; i < len; i++) {
                                            ItemArr[i].classList.remove("highlight");
                                            ItemArr[i].childNodes[0].childNodes[1].style = "color:#666";
                                        }
                                        ItemArr[index].classList.add("highlight");
                                        ItemArr[index].childNodes[0].childNodes[1].style = "color:#fff";
                                        if (ItemArr[index].scrollIntoViewIfNeeded) {
                                            ItemArr[index].scrollIntoViewIfNeeded();
                                        } else {
                                            ItemArr[index].scrollIntoView();
                                        }
                                    }
                                    break;
                                }
                            case "Enter":
                                {
                                    if (!EC_Fmt.isNull(ItemArr)) {
                                        if (document.querySelector(".database-list-item.show.highlight")) {
                                            EC_Fmt.TriggerEvent(document.querySelector(".database-list-item.show.highlight").getElementsByClassName("switch-btn")[0], "click");
                                        } else {
                                            EC_Fmt.TriggerEvent(ItemArr[0].getElementsByClassName("switch-btn")[0], "click");
                                        }
                                    }
                                    break;
                                }
                            default:
                                {
                                    break;
                                }
                        }
                    });

                    Dialog.querySelector("input#SiteSearchInput").addEventListener("keyup", (event) => {
                        switch (event.key) {
                            case "ArrowUp":
                            case "Enter":
                            case "ArrowDown":
                                {
                                    break;
                                }
                            default:
                                {
                                    SiteSwitchSearch(Dialog, event.target.value);
                                    const ItemArr = Array.from(document.querySelectorAll(".database-list-item.show"));
                                    if (ItemArr.length > 0) {
                                        if (ItemArr[0].scrollIntoViewIfNeeded) {
                                            ItemArr[0].scrollIntoViewIfNeeded();
                                        } else {
                                            ItemArr[0].scrollIntoView();
                                        }
                                    }
                                    if (document.querySelector(".database-list-item.show.highlight")) {
                                        document.querySelector(".database-list-item.show.highlight").childNodes[0].childNodes[1].style = "color:#666";
                                    }
                                    for (let i = 0, len = ItemArr.length; i < len; i++) {
                                        ItemArr[i].classList.remove("highlight");
                                    }
                                    break;
                                }
                        }
                    });

                    Dialog.querySelector("input#SiteSearchInput").addEventListener("paste", () => {
                        setTimeout(() => {
                            EC_Fmt.TriggerEvent(Dialog.querySelector("input#SiteSearchInput"), "keyup");
                        }, 1);
                    });

                    InitSiteSwitchData(Dialog);
                }
            });
        });
    }
}

let isDialogDragAttached = false;

function PositionDialog(Dialog) {
    const Mask = document.getElementById("DialogMask");
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;
    let Width;
    let Height;

    Mask.style.width = `${clientWidth}px`;

    if (EC_Fmt.isMobile) {
        Width = clientWidth;
        Height = Dialog.outerHeight + Math.round(clientHeight - Dialog.outerHeight) / 2 - 30;

        if (Height > clientHeight) {
            Height = clientHeight;
        }

        Mask.style.opacity = "0.3";
        Dialog.style.overflow = "auto";
    } else {
        Width = Dialog && Dialog.offsetWidth;
        Height = Dialog && Dialog.offsetHeight;

        if (Width > window.outerWidth) {
            Width = window.outerWidth;
            Dialog.style.overflow = "auto";
        }

        if (Height > window.outerHeight) {
            Height = window.outerHeight;
            Dialog.style.overflow = "auto";
        }
    }

    let Top = Math.floor((window.outerHeight / 2) - (Height / 2));
    let Left = Math.floor((window.outerWidth / 2) - (Width / 2));

    Top = Math.max(Top, 0);
    Left = Math.max(Left, 0);

    Dialog.style.minWidth = `${Width}px`;
    Dialog.style.height = `${Height}px`;
    Dialog.style.marginLeft = "0";
    Dialog.style.marginTop = "0";
    Dialog.style.top = `${Top}px`;
    Dialog.style.left = `${Left}px`;
    Dialog.style.zIndex = "100000";

    const SRDOwner = document.getElementById("SRDOwner");
    if (SRDOwner) {
        SRDOwner.parentElement.style.height = SRDOwner.outerHeight + 2 * EC_Fmt.Null2ZeroInt(SRDOwner.style.borderTopWidth).replace("px", "") + 2 * EC_Fmt.Null2ZeroInt(SRDOwner.style.paddingTop).replace("px", "") + 1;
    }

    const DialogScrollContent = Dialog.querySelector(".ScrollContent");

    if (DialogScrollContent) {
        const DialogScrollContentTable = DialogScrollContent.querySelector("table");
        if (DialogScrollContentTable) {
            DialogScrollContentTable.style.border = "none";
            const DialogScrollContentCells = DialogScrollContentTable.querySelectorAll("td");
            for (let i = 0; i < DialogScrollContentCells.length; i++) {
                DialogScrollContentCells[i].style.border = "none";
                DialogScrollContentCells[i].style.borderBottom = "1px solid #ccc";
            }
        }
    }

    const dragDialog = (handle) => {
        if (isDialogDragAttached) {
            return;
        }

        let currentDialog;
        let startX;
        let startY;

        handle.addEventListener("mousedown", (event) => {
            currentDialog = Dialog;
            startX = event.clientX;
            startY = event.clientY;

            document.body.style.webkitUserSelect = "none";
        });

        const MoveDone = () => {
            if (currentDialog) {
                currentDialog = null;
                startX = 0;
                startY = 0;
                document.body.style.webkitUserSelect = "auto";
            }
        };
        const MoveDialog = (e) => {
            if (currentDialog) {
                let top = (currentDialog.style.top ? parseInt(currentDialog.style.top.replace("px", "")) : 0) + e.clientY - startY;
                let left = (currentDialog.style.left ? parseInt(currentDialog.style.left.replace("px", "")) : 0) + e.clientX - startX;
                const topMaxLimit = window.innerHeight - currentDialog.clientHeight - 3;
                const leftMaxLimit = window.innerWidth - currentDialog.clientWidth;

                if (top < 0) {
                    top = 0;
                }
                if (top > topMaxLimit) {
                    top = topMaxLimit;
                }
                if (left < 0) {
                    left = 0;
                }
                if (left > leftMaxLimit) {
                    left = leftMaxLimit;
                }

                currentDialog.style.top = `${top}px`;
                currentDialog.style.left = `${left}px`;

                startY = e.clientY;
                startX = e.clientX;
            }
        };

        document.addEventListener("mousemove", MoveDialog);
        document.addEventListener("mouseup", MoveDone);

        isDialogDragAttached = true;
    };

    const DialogContent = document.querySelector(".DialogContent");

    if (DialogContent && DialogContent.offsetWidth > 0 && DialogContent.offsetHeight > 0) {
        const DialogHeader = document.querySelector(".DialogHeader");
        const DialogFooter = document.querySelector(".DialogFooter");
        if (EC_Fmt.isMobile) {
            DialogContent.style.overflow = "auto";
        }

        DialogFooter.style.width = DialogContent.offsetWidth;

        dragDialog(DialogHeader);

        Dialog.style.height = DialogContent.outerHeight + DialogHeader.offsetHeight + DialogFooter.offsetHeight;

        if (Dialog.outerHeight > clientHeight) {
            DialogContent.style.height = `${Height - DialogHeader.offsetHeight - DialogFooter.offsetHeight}px`;
        } else {
            DialogContent.style.height = "auto";
        }

        setTimeout(() => {
            Dialog.style.height = DialogContent.outerHeight + DialogHeader.offsetHeight + DialogFooter.offsetHeight;

            if (Dialog.outerHeight > clientHeight) {
                DialogContent.height(Height - DialogHeader.offsetHeight - DialogFooter.offsetHeight);
            } else {
                DialogContent.style.height = "auto";
            }
        }, 1000);
    } else {
        Dialog.classList.add("BoxShowNone");

        const handle = Dialog.querySelector(".DialogLayout>thead");

        dragDialog(handle);
    }
}

function HideDialog(Name) {
    if (Name === "UrlDialog") {
        document.getElementById("UrlFrame").setAttribute("src", "about:blank");
    }

    const DialogMask = document.getElementById("DialogMask");
    if (DialogMask) {
        DialogMask.style.display = "none";
    }
    const myElement = document.getElementById(Name);
    if (myElement) {
        myElement.style.display = "none";
    }
    const embedElements = document.getElementsByTagName("EMBED");
    for (let i = 0; i < embedElements.length; i++) {
        embedElements[i].style.display = "block";
    }
    const pdfIframe = document.getElementById("pdfIframe");
    if (pdfIframe) {
        pdfIframe.style.display = "block";
    }

    document.body.style.overflowX = "auto";
    document.body.style.overflowY = "auto";
    document.body.style.position = "static";
    document.body.style.minWidth = "auto";

    const ScrollPosition = document.scrollPosition;

    if (ScrollPosition) {
        window.scrollTo(ScrollPosition[0], ScrollPosition[1]);
    }
}

function SendEmail(Url, ContentHtml, Embeded, ToEmail) {
    if (!Url) {
        Url = "SendEmail.aspx";
    }

    const EmailForm = document.getElementById("EmailForm");
    if (EmailForm) {
        const Form = document.createElement("form");
        Form.id = "EmailForm";
        Form.name = "EmailPageForm";
        Form.method = "post";
        if (Embeded) {
            Form.action = "SendEmail.aspx?EmbededDialog=True";
        } else {
            Form.action = "SendEmail.aspx";
        }

        let htmlB = "<input type=hidden id=ContentHtml name=ContentHtml>"
            + "<input type=hidden id=ReturnURL name=ReturnURL>";

        if (ToEmail !== undefined) {
            htmlB += `<input type=hidden id=ToEmail name=ToEmail value='${ToEmail}'>`;
        }

        Form.innerHTML = htmlB;

        document.body.appendChild(Form);

        const ReturnURL = EmailForm.querySelector("#ReturnURL");
        if (ReturnURL) {
            ReturnURL.value = Url;
        }

        if (ContentHtml) {
            const ContentHtmlElement = EmailForm.querySelector("#ContentHtml");
            if (ContentHtmlElement) {
                ContentHtmlElement.value = ContentHtml;
            }
        }

        EmailForm.submit();
    }
}

function ToggleMenuCategory(Category, CollapseOtherCategories) {
    const CategoryLayer = document.getElementById(`${Category}Category`);
    let Collapsed = false;

    // Task 645555: Creating Bills has Java Script error
    if (CategoryLayer !== null) {
        if (CategoryLayer.offsetWidth === 0 && CategoryLayer.offsetHeight === 0) {
            CategoryLayer.parentElement.classList.add("CategoryHighlight");
        } else {
            Collapsed = true;
            CategoryLayer.parentElement.classList.remove("CategoryHighlight");
        }

        if (CollapseOtherCategories) {
            const OtherCategories = CategoryLayer.parentElement.parentElement.querySelectorAll("div div[id$='Category']");
            for (let i = 0; i < OtherCategories.length; i++) {
                const category = OtherCategories[i];
                if (category.id && CategoryLayer.id !== category.id) {
                    if (category.offsetWidth === 0 && category.offsetHeight === 0) {
                        category.parentElement.classList.remove("CategoryHighlight");
                    } else {
                        ToggleMenuCategory(category.id.replace("Category", ""), false);
                    }
                }
            }
        }

        const CategoryArrow = document.getElementById(`${Category}Arrow`);

        if (Collapsed) {
            CategoryLayer.style.display = "none";
            CategoryArrow.classList.remove("arrowup");
        } else {
            CategoryLayer.style.display = "block";
            CategoryArrow.classList.add("arrowup");
        }

        if (CategoryLayer.id === "EncompassMobileCategory" && !Collapsed) {
            EncompassMobileItem();
        }
    }
}

function OpenApplicationDownload() {
    if (document.getElementById("EncompassMobileArrow")) {
        if (Menu.classList.contains("MenuCollapsed")) {
            ToggleMainMenu();
        }
        const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
        if (EncompassMobileCategory && getComputedStyle(EncompassMobileCategory).display === "none") {
            // Task 425424
            Menu.scrollTop = 0;

            ToggleMenuCategory("EncompassMobile", true);
        }
    }
}

function OpenKnowledgeHelp(Url) {
    window.open(Url);
}

function get_searchOp(Value) {
    return EC_Fmt.get_searchOp(Value);
}

function Replace(Value, Find, ReplaceVal) {
    return EC_Fmt.ReplaceAll(Value, Find, ReplaceVal);
}

function ToggleFilterHeader() {
    const FilterContent = document.getElementById("FilterContent");
    const FilterCollapsed = document.getElementById("FilterCollapsed");

    if (!(FilterContent.offsetWidth === 0 && FilterContent.offsetHeight === 0)) {
        FilterContent.style.display = "none";
        FilterCollapsed.style.display = "block";
    } else {
        FilterContent.style.display = "block";
        FilterCollapsed.style.display = "none";
    }
}

function ClockIn() {
    let TimeClockActivityID = document.getElementById("TimeClockActivityIDHidden");
    if (TimeClockActivityID) {
        TimeClockActivityID = TimeClockActivityID.value;
    }
    if (EC_Fmt.isInteger(TimeClockActivityID)) {
        fetch(`Home?LogOnType=ClockIn&TimeClockActivityID=${TimeClockActivityID}`, {
            credentials: "same-origin"
        }).then(response => response.text()).then((Data) => {
            if (Data === "Success") {
                window.location.reload();
            } else if (Data === "Already Clocked In") {
                ECP.Dialog.Alert("You are Already Clocked In");
                window.location.reload();
            } else {
                ECP.Dialog.Alert("Unable to Clock In");
            }
        });
    } else {
        ECP.Dialog.Alert("You Must Select an Activity");
    }
}

let SitesData = {};

function InitSiteSwitchData(dialog) {
    SitesData = {};

    EWS.VerifySession(() => {
        // Task 614359: Convert EWS.aspx from an aspx page to API Commands/Dashboard
        // Task 744067: Switch Site:When the switch site is not loaded, an error will be reported when input is input
        ECP.Dialog.ShowLoading("Loading......", dialog.firstElementChild);
        fetch(`api?APICommand=GetSiteDatabase&EncompassID=${Distributor}`, {
            credentials: "same-origin"
        }).then(response => response.json()).then((result) => {
            SitesData = result;
            let SitesHTML = `<input type="text" style="display:none">`;
            for (let i = 0; i < SitesData.Sites.length; i++) {
                const site = SitesData.Sites[i];
                SitesHTML += `<tr class="database-list-item show"data-site=${site.Name}>`
                    + "<td class=full-width>"
                    + ` <span class=database-name>${site.Name}</span>`
                    + "</td>"
                    + "<td>"
                    + ` <input class=switch-btn type=button onclick="SwitchSiteButton(${i})"value=${Switch}>`
                    + "</td>"
                    + "</tr>";
            }
            // Task 443511
            if (SitesHTML === "") {
                SitesHTML += "No sites available to switch to.";
            }

            dialog.querySelector(".database-list").innerHTML = SitesHTML;
            ECP.Dialog.HideLoading();
            // Task 917191: System Error: JavaScript Error: includes/DefaultNoEchatAll.min.js (1) - Uncaught TypeError: Cannot read property 'length' of undefined
            const SiteSearchInput = document.getElementById("SiteSearchInput");
            SiteSearchInput.removeAttribute("disabled");
            if (SiteSearchInput) {
                SiteSearchInput.focus();
            }
        });
    });
}

function SiteSwitchSearch(dialog, search) {
    // Task 752570: User with AllDatabases permission did not get an AuthenticationsSites record created for the Founders database
    const myItemArr = dialog.querySelectorAll(`.database-list-item`);
    if (!EC_Fmt.isNull(search)) {
        for (let i = 0; i < SitesData.Sites.length; i++) {
            if (SitesData.Sites[i].Name.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                myItemArr[i].classList.add("show");
                myItemArr[i].classList.remove("hidden");
            } else {
                myItemArr[i].classList.add("hidden");
                myItemArr[i].classList.remove("show");
            }
        }
    }
}

function SwitchSiteButton(site) {
    // AuthenticationSiteID
    document.getElementById("SiteSwitchHidden").value = SitesData.Sites[site].ID;
    // EncompassID
    document.getElementById("SiteSwitchHiddenName").value = SitesData.Sites[site].Name;
    // Domain
    document.getElementById("DomainHiddenName").value = SitesData.Sites[site].URL;
    const SwitchSiteForm = document.getElementById("SiteSwitchForm");
    if ((window.event.ctrlKey || window.event.metaKey) && SwitchSiteForm) {
        SwitchSiteForm.setAttribute("target", "_blank");
    }
    document.getElementById("SiteSwitchForm").submit();
    if (SwitchSiteForm) {
        SwitchSiteForm.setAttribute("target", "_self");
    }
}

async function ViewNewDashboards(ShowUnshared) {
    ECP.Dialog.ShowLoading();
    const mySetShowUnsharedDashboardRequest = new ECP.EC_Request("Dashboard_SetShowUnsharedDashboard");
    mySetShowUnsharedDashboardRequest.AddRequestVariable("ShowUnshared", ShowUnshared);
    await mySetShowUnsharedDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

async function ShowHiddenDashboards(ShowDashboards) {
    ECP.Dialog.ShowLoading();
    const mySetShowDefaultDashboardRequest = new ECP.EC_Request("Dashboard_SetShowDefaultDashboard");
    mySetShowDefaultDashboardRequest.AddRequestVariable("ShowHidden", ShowDashboards);
    await mySetShowDefaultDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

async function ShowOtherSiteDashboard(ShowOther) {
    ECP.Dialog.ShowLoading();
    const mySetShowOtherSiteDashboardRequest = new ECP.EC_Request("Dashboard_SetShowOtherSiteDashboard");
    mySetShowOtherSiteDashboardRequest.AddRequestVariable("ShowOther", ShowOther);
    await mySetShowOtherSiteDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

function ShowHideFilters() {
    const content = document.getElementById("FilterContent");
    const TableFilter = document.getElementById("TableFilter");

    if (content && TableFilter) {
        if (!(content.offsetWidth === 0 && content.offsetHeight === 0)) {
            TableFilter.classList.add("ews-icon-plus-square-o");
            TableFilter.classList.remove("ews-icon-minus-square-o");
        } else {
            TableFilter.classList.add("ews-icon-minus-square-o");
            TableFilter.classList.remove("ews-icon-plus-square-o");
        }

        content.style.display = (content.style.display === "none") ? "block" : "none";
    }
}

// Task 941168: Quickbooks Online sync shows blank page while running
async function WriteEncompassMobileItemHtml(clientApplication, clientOS, clientOSVersion) {
    const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
    EncompassMobileCategory.innerHTML = "<div class=align-center>loading...</div>";

    const myRequest = new ECP.EC_Request("GetEncompassMobileList");
    myRequest.AddRequestVariable("ClientApplication", clientApplication);
    myRequest.AddRequestVariable("ClientOS", clientOS);
    myRequest.AddRequestVariable("ClientOSVersion", clientOSVersion);

    const data = await myRequest.Submit();
    let contentHtml = "";

    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        contentHtml += `<h2 style=border-bottom:0;margin-bottom:0;padding-bottom:12px>${item.ClientApplication}</h2>`;
        contentHtml += `<div class=MainMenuItem><a href="${item.DownloadURL}">Install ${item.ClientApplication} ${item.ClientVersion}</a></div>`;
    }

    EncompassMobileCategory.innerHTML = contentHtml;
}

function EncompassMobileItem() {
    const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
    const isEmptyContent = EncompassMobileCategory && EncompassMobileCategory.innerHTML.trim() === "";
    const isMobileDevice = navigator.maxTouchPoints > 0;

    if (EC_Fmt.isAndroid || EC_Fmt.isIOS) {
        if (isEmptyContent) {
            EncompassMobileCategory.innerHTML = "<div class=align-center>loading...</div>";

            // Task 960025: Log in window appears in front of report after using a quick link that has required login = false
            if (!IsImpersonateUser) {
                EWS.VerifySession(() => {
                    fetch("api?APICommand=GetApplicationsCategoryHtml", {
                        credentials: "same-origin"
                    }).then(response => response.text()).then((result) => {
                        EncompassMobileCategory.innerHTML = result;
                    });
                });
            }
        }
    } else if (navigator.userAgent.toLowerCase().indexOf("mac") > 0 && isMobileDevice) {
        if (isEmptyContent) {
            WriteEncompassMobileItemHtml(6, 2, 13);
        }
    } else if (navigator.userAgent.toLowerCase().indexOf("chrome") > 0 && isMobileDevice) {
        if (isEmptyContent) {
            WriteEncompassMobileItemHtml(7, 3, 7);
        }
    } else if (document.querySelector("#Menu .encompass-mobile")) {
        document.querySelector("#Menu .encompass-mobile").remove();
    }
}

// Task 1060296: Standardizing javascript Dialogs: Need to delete the code for the old SiteMapHeader.js: ShowDialog()
// Has been replaced with EditColumn, JS replaced whit EditLanguageString()
// function SaveLanguageStrings() {
//     const languageStringsArr = Array.from((new FormData(document.getElementById("LanguageStringsEditForm"))).entries());
//     const languageStringsData = languageStringsArr.map(item => ({
//         F: item[0],
//         V: item[1]
//     }));
//     const myRequest = new ECP.EC_Request("SaveLanguageStrings");

//     myRequest.SetReturnType(ECP.EC_ReturnType.Text);
//     myRequest.AddRequestVariable("LanguageStringsData", JSON.stringify({
//         root: languageStringsData
//     }), ECP.EC_Verb.Post);
//     myRequest.AddRequestVariable("Language", document.querySelector("#LanguageStringsEditForm #Language").value, ECP.EC_Verb.Post);

//     const loadingDialog = ECP.Dialog.ShowLoading();
//     loadingDialog.firstElementChild.style.zIndex = parseInt(document.getElementById("EditTranslationDialog").style.zIndex) + 10;

//     myRequest.Submit().then(() => {
//         ECP.Dialog.HideLoading();

//         window.location.reload();
//     });
// }

/* Task 748465: Make ECP header mobile friendly */
function ShareButtonHandle(shareButton, event) {
    if (shareButton) {
        event.stopPropagation();
        Load_QuicklinkMenu(shareButton, `Home?${EC_Fmt.Get_QueryString(" ")}`, "Dashboard");
    }
}

function displayCommandMenu(name, ele, event) {
    event.stopPropagation();
    EWS.Command.ShowMenu(name, ele);
}

function showRemindMeDialog(name, ele, event) {
    displayCommandMenu(name, ele, event);
}

function ShowReMindMeDialog() {
    EWS.VerifySession(() => {
        const dateTimeNow = EC_Fmt.DateTimeParseFormat(EC_Fmt.ScreenFmt(new Date(), ECP.DataType._DateTime));
        const content = `<div style="min-height:24px;position:relative;font-size:10pt;color:#000;cursor:pointer;padding:8px 15px 0 15px">`
            + `<div class=ews-menu-label><b>Remind Me</b>`
            + `<div class=tip-container>`
            + ` <span class=ews-icon-info style=font-size:12pt></span>`
            + ` <span class=tip-description style=top:20px>`
            + `  <b>Tip:</b>`
            + `  <br>Set a date and time in the dialog`
            + `  <br>below and the Remind Me`
            + `  <br>feature will send you an eChat`
            + `  <br>at that time with a link that`
            + `  <br>takes you back to the page you are on right now.`
            + ` </span>`
            + `</div>`
            + `</div>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:#666;cursor:pointer;padding:0 15px">`
            + ` <input type=Text name=remind title="Remind Me"placeholder="Reminder Message Text"style="width:300px;border:1px #ccc solid"id=remind>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:#000;cursor:pointer;padding:8px 15px 0 15px">`
            + ` <div class=ews-menu-label><b>Reminder Date/Time</b></div>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:#666;cursor:pointer;padding:0 15px">${ECP.HTML.DateTimeInput("myDateTime", "DateTimeField", true, dateTimeNow, "Current Date Time", 1, 290, true, dateTimeNow)}</div>`;
        const dialog = ECP.Dialog.ShowDialog("Remind Me", content, {
            width: 350,
            height: 280,
            confirmButtonTitle: "Set Reminder",
            async confirmButtonAction() {
                ECP.Dialog.ShowLoading();

                const date = dialog.querySelector("#DateTimeField").value;
                const title = dialog.querySelector("#remind").value;
                if (!date || !title) {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("Please input information.");
                    return;
                }

                const delayRequest = new ECP.EC_Request("SendRemindMeEChatMessage");

                delayRequest.AddRequestVariable("DelayedSendTime", EC_Fmt.DateTimeParseFormat(date), ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Title", title, ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Url", window.location.href, ECP.EC_Verb.Post);
                const message = await delayRequest.Submit();
                if (message.State === "Success") {
                    // Task 1024699: Remind Me: Use Snackbar notification instead of pop-up after scheduling a reminder
                    ECP.HTML.Snackbar("Remind Me Event has been created.", "Success");
                } else {
                    ECP.Dialog.Alert(message.errors[0].detail);
                }
                ECP.Dialog.HideLoading();
            }
        });
    });
}

function ShowBetaFeedbackDialog() {
    if (AuthenticationID > 0) {
        EWS.VerifySession(() => {
            // Task 1064388: UI Adjustments for the submit feedback modal
            const UserName = document.querySelector("div [name='UserMenu']").innerText.split("@")[0];
            const content = `<ecp-sectionmessage type="information">`
                + `This feedback should pertain to the beta version of this dashboard. For all other questions/comments, please`
                + ` <a href="Home?DashboardID=168976&TableEdit=Tasks">create a task</a>.`
                + `</ecp-sectionmessage>`
                + `<div style="display:padding:20px 0">`
                + `<div style="display:flex;align-items:center;padding:24px 0 0 10px">`
                + ` <span style=padding-right:30px;color:#999>Dashboard</span>`
                + ` <span style=color:#444>${document.head.querySelector("title").innerText}</span>`
                + `</div>`
                + `<div style="display:flex;align-items:center;padding:24px 0 0 10px">`
                + ` <span style=padding-right:30px;color:#999>Your name</span>`
                + ` <span style=color:#444> ${UserName} </span>`
                + `</div>`
                + `<div style="display:block;align-items:center;padding:24px 10px 0 10px">`
                + ` <textarea id=FeedbackDetail placeholder="Feedback..."name=FeedbackDetail encreq=true style=width:100%;height:160px;color:#6e6a6a;padding:5px></textarea>`
                + `</div>`
                + `</div>`;

            const Dialog = ECP.Dialog.ShowDialog("Submit beta dashboard feedback", content, {
                width: 560,
                barPosition: "top",
                cancelButtonTitle: "Cancel",
                confirmButtonTitle: "Submit Feedback",
                async confirmButtonAction() {
                    ECP.Dialog.ShowLoading();
                    // Get Dashboard and UserData
                    const myDashboardData = new ECP.EC_TableView("Dashboards");
                    myDashboardData.AddSubTableJoinID("Dashboards_Applications");
                    myDashboardData.AddSubTableColumn("Dashboards_Applications", "Application");
                    myDashboardData.AddFilter("DashboardID", EC_Fmt.GetPageParameter("DashboardID"), ECP.EC_Operator.Equals);
                    const results = await myDashboardData.GetResults();
                    const myRecordSet = new ECP.EC_Recordset(results).Records[0];

                    // Create Task
                    let FeedbackDetail = Dialog.querySelector("#FeedbackDetail").value;
                    FeedbackDetail += `<br><br><b>User:${UserName}<br>EncompassID:${Distributor}`;
                    FeedbackDetail = `Beta Dashboard Feedback:<br>${FeedbackDetail}`;

                    const myRequest = new ECP.EC_Request("BI_CreateTask");

                    myRequest.AddRequestVariable("Detail", FeedbackDetail, ECP.EC_Verb.Get);
                    myRequest.AddRequestVariable("Task", `Beta Dashboard feedback submitted for the ${myRecordSet.Dashboard} dashboard in the ${EC_Fmt.RemoveHTMLFromStr(myRecordSet.ApplicationID)} application`, ECP.EC_Verb.Get);
                    myRequest.AddRequestVariable("AuthenticationID", myRecordSet.OwnerAuthenticationID_DBValue, ECP.EC_Verb.Get);
                    myRequest.SetReturnType(ECP.EC_ReturnType.Json);

                    const data = await myRequest.Submit();
                    const TaskID = data.TaskID;

                    ECP.Dialog.HideLoading();
                    if (TaskID) {
                        ECP.Dialog.Alert("A Task has been created");
                    } else {
                        ECP.Dialog.Alert("Task failed to be sent to support, please contact support your feedback or log a task at infrontsmart.com");
                    }
                }
            });
        });
    }
}

function ShowToolTipMessage() {
    const tipContainers = document.querySelectorAll(".tip-container");
    for (let i = 0; i < tipContainers.length; i++) {
        tipContainers[i].addEventListener("mouseenter", () => {
            const tipMessage = tipContainers[i].querySelector(".tip-description");
            tipMessage.style.display = "block";
            // Task 764637: Replace the Top Tips icon and make the pop-up dialog fixed pop-up display position in UI-Kit
            if (window.innerWidth - tipContainers[i].getBoundingClientRect().left > 222) {
                tipMessage.style.left = 0;
            } else {
                tipMessage.style.right = 0;
            }
        });

        tipContainers[i].addEventListener("mouseleave", () => {
            const tipMessage = tipContainers[i].querySelector(".tip-description");
            tipMessage.style.display = "none";
        });
    }
}

// Task 1060296: Standardizing javascript Dialogs: Need to delete the code for the old SiteMapHeader.js: ShowDialog()
function EditLanguageString() {
    let url = `Home?DashboardID=100101&Action=EditColumn&TableEdit=LanguageStrings&Column=TranslationString&SelectMaxRecords=5000&TableName=LanguageStrings&SelectDisplayInParent=LanguageString%2CLanguage%2COnMobile%2CTranslationString%2CTimeUpdated%2CUpdatedBy%2CTimeCreated%2CCreatedBy&Parameters=F:Language~V:${EC_Fmt.userLanguage}~O:E|F:LanguageString~V:`;
    url += encodeURIComponent(Object.keys(EC_Fmt.LocaleStrings).map(key => `${key}`).join("^"));
    url += `~O:E&`;
    window.open(url);
}

function refreshMenu() {
    EWS.ClearMenuCache(() => {
        clearDashboardMenuCache();
        window.location.reload(true);
    });
}